<div class="split-panel-btn" [class.active]="active$ | ngrxPush" (click)="handleClick()" pTooltip="Toggle preview pane" [tooltipPosition]="device === 'desktop' ? 'right' : 'left'" >
    <ng-container *ngIf="active$ | ngrxPush">
        <i class="pi pi-align-justify"></i>
    </ng-container>
    <ng-container *ngIf="!(active$ | ngrxPush)">
        <icon-vertical-split color="var(--surface-0)"></icon-vertical-split>    
    </ng-container>
</div>